module.exports = __webpack_public_path__ + "static/media/message.13d42499.gif";